import React from 'react';

const ContactMap = () => {
    return (
        <section className="wpo-contact-map-section" >
            <div className="wpo-contact-map">
                <iframe title='comtact-map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2787.8160066989303!2d69.7448228755187!3d40.24064116633872!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38b0523a327641c5%3A0x937ee5467be89618!2sUlitsa%20Bobozhon%20Gafurov%2C%20Isfisor%2C%20Tadschikistan!5e0!3m2!1sde!2s!4v1743489425763!5m2!1sde!2s" width="600" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

            </div>
        </section >
    );
};

export default ContactMap;